<template>
    <div class="infoModify">
        <div class="infoModify-box">
            <Title text="基础信息修改" />
            <div class="cont">
                <div class="top">
                    <el-button type="primary" @click="modifyClick">申请修改</el-button>
                </div>
                <el-table
                    :header-cell-style="{ background: '#eef1f6', color: '#606266' }"
                    :data="tableData"
                    border
                    style="width: 100%;margin-top: 20px;"
                >
                    <el-table-column prop="up_title" label="新姓名" align="center"></el-table-column>
                    <el-table-column prop="house_img" label="户口本照片" align="center">
                        <template v-slot="{row}">
                            <el-image 
                                v-if="row.house_img ? true : false"
                                class="see-img"
                                :src="row.house_img" 
                                fit="contain"
                                :preview-src-list="[row.house_img]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="new_card_img_just" label="新身份证正面照" align="center">
                        <template v-slot="{row}">
                            <el-image 
                                v-if="row.new_card_img_just ? true : false"
                                class="see-img"
                                :src="row.new_card_img_just" 
                                fit="contain"
                                :preview-src-list="[row.new_card_img_just]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="new_card_img_back" label="新身份证反面照" align="center">
                        <template v-slot="{row}">
                            <el-image 
                                v-if="row.new_card_img_back ? true : false"
                                class="see-img"
                                :src="row.new_card_img_back" 
                                fit="contain"
                                :preview-src-list="[row.new_card_img_back]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="cert_img" label="个人更名申请书" align="center">
                        <template v-slot="{row}">
                            <el-image 
                                v-if="row.cert_img ? true : false"
                                class="see-img"
                                :src="row.cert_img" 
                                fit="contain"
                                :preview-src-list="[row.cert_img]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="old_card_img" label="旧身份证照片" align="center">
                        <template v-slot="{row}">
                            <el-image 
                                v-if="row.old_card_img ? true : false"
                                class="see-img"
                                :src="row.old_card_img" 
                                fit="contain"
                                :preview-src-list="[row.old_card_img]">
                            </el-image>
                        </template>
                    </el-table-column>
                    <el-table-column prop="is_check" align="center" label="审核状态">
                        <template slot-scope="{ row }">
                            <el-tag :type="row.is_check | isCheckStyle">
                                {{ row.is_check | isCheckFilter }}
                            </el-tag>
                        </template>
                    </el-table-column>
                    <el-table-column prop="check_user_title" align="center" label="审核人"></el-table-column>
                    <el-table-column prop="check_at" align="center" label="审核时间"></el-table-column>
                    <el-table-column prop="check_remark" align="center" label="审核备注"></el-table-column>
                </el-table>
            </div>
        </div>
        <el-dialog title="申请修改" :visible.sync="isShowModifyInfo" width="40%" @close="modifyInfoClose">
            <el-form 
                ref="info" 
                :model="infoData" 
                :rules="infoRules"
                label-width="200px">
                <el-form-item label="新姓名" prop="up_title">
                    <el-input v-model="infoData.up_title" placeholder="请输入新姓名"></el-input>
                </el-form-item>
                <el-form-item label="户口本照片" prop="house_img_data">
                    <uploadFile
                        ref="uploadHouseImg"
                        @handleChange="choiceImg($event, 'house_img')"
                        @handleRemove="handleRemove($event, 'house_img')"
                        :fileLists="infoData.house_img_data"
                        :isShowModal="false"
                    />
                </el-form-item>
                <el-form-item label="新身份证正面照(人像面)" prop="new_card_img_just_data">
                    <uploadFile
                        ref="uploadNewCardImgJust"
                        @handleChange="choiceImg($event, 'new_card_img_just')"
                        @handleRemove="handleRemove($event, 'new_card_img_just')"
                        :fileLists="infoData.new_card_img_just_data"
                        :isShowModal="false"
                    />
                </el-form-item>
                <el-form-item label="新身份证反面照(国徽面)" prop="new_card_img_back_data">
                    <uploadFile
                        ref="uploadNewCardImgBack"
                        @handleChange="choiceImg($event, 'new_card_img_back')"
                        @handleRemove="handleRemove($event, 'new_card_img_back')"
                        :fileLists="infoData.new_card_img_back_data"
                        :isShowModal="false"
                    />
                </el-form-item>
                <el-form-item label="个人更名申请书" prop="cert_img_data">
                    <uploadFile
                        ref="uploadCertImg"
                        @handleChange="choiceImg($event, 'cert_img')"
                        @handleRemove="handleRemove($event, 'cert_img')"
                        :fileLists="infoData.cert_img_data"
                        :isShowModal="false"
                    />
                </el-form-item>
                <el-form-item label="旧身份证照片(人像面)" prop="old_card_img_data">
                    <uploadFile
                        ref="uploadOldCardImg"
                        @handleChange="choiceImg($event, 'old_card_img')"
                        @handleRemove="handleRemove($event, 'old_card_img')"
                        :fileLists="infoData.old_card_img_data"
                        :isShowModal="false"
                    />
                </el-form-item>
            </el-form>
            <div slot="footer" class="dialog-footer">
                <el-button @click="isShowModifyInfo = false">取消</el-button>
                <el-button type="primary" @click="submitInfo">提交</el-button>
            </div> 
        </el-dialog>
    </div>
</template>

<script>
import {putObject} from '@/utils/upload';
// import {isAssetTypeAnImage} from '@/utils/func';
import {adultStudentUserModify, adultStudentUserModifyUp} from '@/api/basic';
import uploadFile from '@/components/uploadFile';
export default {
    name: 'infoModify',
    components: { uploadFile },
    filters: {
        // 审核状态
        isCheckFilter(v){
            let obj = {
                0: '待审核',
                1: '已通过', 
                2: '未通过', 
            };
            return obj[v];
        },
        // 审核状态 样式
        isCheckStyle(v){
            let obj = {
                0: '', 
                1: 'success', 
                2: 'danger', 
            };
            return obj[v];
        },
    },
    data(){
        return {
            tableData: [], 

            //申请修改 
            isShowModifyInfo: false,  
            infoData: {
                up_title: '',  //新姓名
                house_img: '',  //户口本照片
                house_img_data: [],
                new_card_img_just: '', //新身份证正面照
                new_card_img_just_data: [],
                new_card_img_back: '',  //新身份证反面照
                new_card_img_back_data: [],
                cert_img: '',  //个人更名申请书
                cert_img_data: [],
                old_card_img: '',  //旧身份证照片
                old_card_img_data: [],
            },
            infoRules: {
                up_title: [{ required: true, message: "请输入新姓名", trigger: "blur" }],
                house_img_data: [{ required: true, message: "请选择户口本照片", trigger: "change" }],
                new_card_img_just_data: [{ required: true, message: "请选择新身份证正面照(人像面)", trigger: "change" }],
                new_card_img_back_data: [{ required: true, message: "请选择新身份证反面照(国徽面)", trigger: "change" }],
                cert_img_data: [{ required: true, message: "请选择个人更名申请书", trigger: "change" }],
                // old_card_img_data: [{ required: true, message: "请选择旧身份证照片(人像面)", trigger: "change" }],
            },
        };
    },
    created(){
        this.getData();  //获取数据
    },
    methods: {
        // 弹窗 申请修改 提交
        submitInfo(){
            this.$refs["info"].validate(async (valid) => {
                if (valid) {
                    // 提交前 先上传图片
                    let houseImg = this.uploadImg('house_img');
                    let newCardImgJust = this.uploadImg('new_card_img_just');
                    let newCardImgBack = this.uploadImg('new_card_img_back');
                    let certImg = this.uploadImg('cert_img');
                    let oldCardImg = this.uploadImg('old_card_img');
                    let funcs = [houseImg, newCardImgJust, newCardImgBack, certImg, oldCardImg];
                    // let uploadImgFirstPhone = this.uploadImg('first_phone');
                    Promise.all(funcs).then(res => {
                        let {
                            up_title,
                            house_img,
                            new_card_img_just,
                            new_card_img_back,
                            cert_img,
                            old_card_img,
                        } = this.infoData;
                        let data = {
                            up_title,
                            house_img,
                            new_card_img_just,
                            new_card_img_back,
                            cert_img,
                            old_card_img,
                        };
                        adultStudentUserModifyUp(data).then(res => {
                            if(res.code == 200){
                                this.$message.success('提交成功');
                                this.isShowModifyInfo = false;
                                this.getData();  //获取数据
                            }
                        });
                    });
                }
            });
        },
        // 点击 申请修改
        modifyClick(){
            this.isShowModifyInfo = true;
        },
        // 弹窗 申请修改 关闭
        modifyInfoClose(){
            this.infoData = {
                up_title: '',  //新姓名
                house_img: [],  //户口本照片
                new_card_img_just: [], //新身份证正面照
                new_card_img_back: [],  //新身份证反面照
                cert_img: [],  //个人更名申请书
                old_card_img: [],  //旧身份证照片
            };
            this.$nextTick(() => {
                this.$refs['info'].clearValidate();
            });
        },
        // 上传图片
        uploadImg(data){
            return new Promise((resolve, reject)=>{
                if (this.infoData[data + '_data'].length > 0) {
                    let type = this.infoData[data + '_data'][0].name.split('.').pop();
                    // 先上传头像再提交
                    putObject(this.infoData[data + '_data'][0], (url) => {
                        this.infoData[data] = url;
                        resolve();
                    }, null, 'student', type);
                }else{
                    resolve();
                }
            });
        },
        // 上传照片
        choiceImg(data, type) {
            this.infoData[type] = '';
            this.infoData[type + '_data'] = data.fileList;
        },
        // 移除照片
        handleRemove(data, type) {
            this.infoData[type] = '';
            this.infoData[type + '_data'] = data.fileList;
        },
        // 获取数据
        getData(){
            adultStudentUserModify().then(res => {
                if(res.code == 200){
                    this.tableData = res.result;
                }
            });
        },
    },
}
</script>

<style lang="scss" scoped>
.infoModify{
    padding: 20px;
    min-height: $contentH;
    padding-bottom: 0;
    .infoModify-box{
        min-height: inherit;
        background-color: #fff;
        padding: 20px;
        .cont{
            .top{
                text-align: right;
            }
        }
    }
}
</style>